import { api } from '../../services/api';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TokenDetail {
  token: string;
  expires: string;
}

export interface LoginResponse {
  success: boolean;
  message: string;
  data: {
    tokens: {
      access: TokenDetail;
      refresh: TokenDetail;
    };
    user: {
      id: string;
      name: string;
      email: string;
      profile_image?: string;
      companyId: string;
      company?: {
        id: string;
        name: string;
        logo?: string;
      };
    };
  };
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['User'],
    }),
    exchangeToken: builder.mutation<LoginResponse, { accessToken: string; refreshToken: string }>({
      query: (tokens) => ({
        url: '/auth/exchange-token',
        method: 'POST',
        body: tokens,
      }),
      invalidatesTags: ['User'],
    }),
    refreshTokens: builder.mutation<LoginResponse, { refreshToken: string }>({
      query: (body) => ({
        url: '/auth/refresh-tokens',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useLoginMutation, useExchangeTokenMutation, useRefreshTokensMutation } = authApi;
